import { AuthService } from './../_services/auth.service';
import { Role } from './../_models/role';
import { Directive, Input, TemplateRef, ViewContainerRef } from '@angular/core';

@Directive({
  selector: '[rbacAllow]',
})
export class RbacAllowDirective {
  allowedRoles: Role[];
  user: any;
  userRole: any;
  constructor(
    private templateRef: TemplateRef<any>,
    private viewContainer: ViewContainerRef,
    private authService: AuthService
  ) {
    this.user = this.authService.getLoggedInUser();
    this.userRole = this.user.admin;
  }

  @Input()
  set rbacAllow(allowedRoles: Role[]) {
    this.allowedRoles = allowedRoles;
    if (!this.allowedRoles || this.allowedRoles.length === 0 || !this.user) {
      this.viewContainer.clear();
      return;
    }

    const allowed: boolean = this.allowedRoles.includes(this.userRole);

    if (allowed) {
      this.viewContainer.createEmbeddedView(this.templateRef);
    } else {
      this.viewContainer.clear();
    }
  }
}
